import React from "react";

const ViewCouncil = () => {
  return <div>ViewCouncil</div>;
};

export default ViewCouncil;
